// logManagement.js

const LOCAL_STORAGE_KEY = "logManagementState";

// Initialize state from localStorage or default to empty maps.
const logState = (() => {
  if (typeof window !== "undefined") {
    const savedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      return {
        componentFlags: new Map(parsedState.componentFlags),
        pathFlags: new Map(parsedState.pathFlags),
        strictMode: parsedState.strictMode ?? true,
        logMainPath: parsedState.logMainPath ?? true,
        bothPathAndComponent: parsedState.bothPathAndComponent ?? true,
      };
    }
  }
  return {
    componentFlags: new Map(),
    pathFlags: new Map(),
    strictMode: true,
    logMainPath: true,
    bothPathAndComponent: true,
  };
})();

// Helper function to save the state to localStorage.
function saveState() {
  if (typeof window !== "undefined") {
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({
        componentFlags: Array.from(logState.componentFlags.entries()),
        pathFlags: Array.from(logState.pathFlags.entries()),
        strictMode: logState.strictMode,
        logMainPath: logState.logMainPath,
        bothPathAndComponent: logState.bothPathAndComponent,
      })
    );
  }
}

function resetState() {
  console.log("Reset Local Storage State");
  localStorage.removeItem(LOCAL_STORAGE_KEY);
  window.location.reload();
}

function pathOk(path) {
  if (path==null) {
    return false;
  }
  if (logState.pathFlags.get(path)) {
    return true;
  }
  if (logState.strictMode) {
    return false;
  } else {
    const parts = path.split(".");
    for (let i = 1; i < parts.length; i++) {
      const subPath = parts.slice(0, i).join(".");
      if (logState.pathFlags.get(subPath)) {
        return true;
      }
    }
  }
  return false;
}

const NO_DEBUGS = false;
const DEBUG_ALL = false;
function canDebug(componentName, path, mainPath) {
  if (NO_DEBUGS) {
    return false;
  }
  if (DEBUG_ALL) {
    return true;
  }
  // Initialize flags for new components/paths.
  !logState.componentFlags.has(componentName) && setComponentDebug(componentName, false);
  !logState.pathFlags.has(path) && setPathDebug(path, false);

  let ans;

  if (path){
    if (path === mainPath && logState.logMainPath) {
      ans = true;
    }
    else {
      if (logState.bothPathAndComponent) {
        // Return true if both the component and path flag are enabled.
        ans = logState.componentFlags.get(componentName) && pathOk(path);
      }
      else {
        // Return true if either the component or path flag is enabled.
        ans = logState.componentFlags.get(componentName) || pathOk(path);
      }
    }
  }
  else {
    ans = logState.componentFlags.get(componentName);
  }

  return ans;
}

// Update flags (used by the UI to toggle logging).
function setComponentDebug(componentName, flag) {
  //console.log("setComponentDebug", { componentName, flag });
  logState.componentFlags.set(componentName, flag);
  saveState();
}

function setPathDebug(path, flag) {
  //console.log("setPathDebug", { path, flag });
  logState.pathFlags.set(path, flag);
  saveState();
}

function setStrictMode(flag) {
  console.log("setStrictMode", { flag });
  logState.strictMode = flag;
  saveState();
}

function setLogMainPath(flag) {
  console.log("setLogMainPath", { flag });
  logState.logMainPath = flag;
  saveState();
}

function getLogState() {
  const componentFlags = logState.componentFlags;
  const pathFlags = logState.pathFlags;
  const componentFlagsEntries = componentFlags.entries();
  const pathFlagsEntries = pathFlags.entries();
  const componentFlagsArray = Array.from(componentFlagsEntries);
  const pathFlagsArray = Array.from(pathFlagsEntries);
  //console.log("getLogState", status);
  return {
    componentFlags: componentFlagsArray,
    pathFlags: pathFlagsArray,
    strictMode: logState.strictMode,
    logMainPath: logState.logMainPath,
    bothPathAndComponent: logState.bothPathAndComponent,
  };
}

function toggleBothPathAndComponent(flag) {
  logState.bothPathAndComponent = flag;
}

function setAllComponents(flag) {
  for (let key of logState.componentFlags.keys()) {
    logState.componentFlags.set(key, flag);
  }
}

function setAllPaths(flag) {
  for (let key of logState.pathFlags.keys()) {
    logState.pathFlags.set(key, flag);
  }
}

export {
  canDebug,
  setComponentDebug,
  setPathDebug,
  setStrictMode,
  setLogMainPath,
  getLogState,
  toggleBothPathAndComponent,
  setAllComponents,
  setAllPaths,
  resetState,
};
